import { Controller } from "@hotwired/stimulus"

// Drives the preset selector on the OAuth consent screen
// (Read only / Full access / Custom). Pure UI sugar — the backend only
// reads the resulting `granted_scopes[]` checkboxes.
export default class extends Controller {
  static targets = ["scope", "presetInput", "presetButton"]

  connect() {
    this.syncPreset()
  }

  applyPreset(event) {
    const preset = event.target.value
    if (preset === "custom") {
      this.refreshButtonStyles(preset)
      return
    }
    this.scopeTargets.forEach(checkbox => {
      checkbox.checked = preset === "full_access" || checkbox.dataset.readOnly === "true"
    })
    this.refreshButtonStyles(preset)
  }

  syncPreset() {
    const allChecked = this.scopeTargets.every(cb => cb.checked)
    const onlyReadChecked = this.scopeTargets.every(cb =>
      cb.dataset.readOnly === "true" ? cb.checked : !cb.checked,
    )

    let preset
    if (allChecked) {
      preset = "full_access"
    } else if (onlyReadChecked) {
      preset = "read_only"
    } else {
      preset = "custom"
    }

    this.presetInputTargets.forEach(input => {
      input.checked = input.value === preset
    })
    this.refreshButtonStyles(preset)
  }

  refreshButtonStyles(preset) {
    this.presetButtonTargets.forEach(btn => {
      btn.classList.toggle("btn-primary", btn.dataset.preset === preset)
      btn.classList.toggle("btn-default", btn.dataset.preset !== preset)
    })
  }
}
